import React from 'react';
import { cn } from '../../utils';
import { AssetBase } from '../../types';

type Props = {
  onAdd?: () => void;
  asset?: AssetBase;
  className?: string;
};

const ImageElement = ({ asset, onAdd, className = '' }: Props) => (
  <div
    className={cn(
      'h-[158px] w-[140px] flex-shrink-0 rounded bg-linear-dark p-[1px] shadow-glow-inset',
      'relative flex items-center justify-center overflow-hidden',
      className,
      !asset && 'border border-marine bg-transparent',
    )}
  >
    {asset && (
      <div className='relative w-full overflow-hidden rounded'>
        <span
          className={`
            absolute left-1 top-1 w-fit truncate whitespace-nowrap rounded border border-neon-green
            bg-radial-border px-2 py-1 text-xs font-medium text-white shadow-inset-combo
          `}
        >
          {`${asset.type.slice(0, 1).toUpperCase()}${asset.type.slice(1)}`}
        </span>

        <img
          src={asset.thumbnail}
          alt={asset.name}
          className='h-[156px] w-full object-cover'
        />

        <div
          className={`
            absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/60 to-transparent
          `}
        />

        <div className='absolute bottom-0 left-1 w-[130px] p-2 font-medium'>
          <div className='truncate whitespace-nowrap text-lg text-white'>
            {asset.name}
          </div>

          <div className='truncate whitespace-nowrap text-sm text-teal-2'>
            {asset.description}
          </div>
        </div>
      </div>
    )}

    {onAdd && (
      <button
        onClick={onAdd}
        className={`
          absolute inset-0 m-auto flex h-[44px] w-[44px] cursor-pointer items-center justify-center
          rounded-full border border-marine bg-linear-custom
          hover:bg-radial-border
        `}
      >
        <i className='fa-solid fa-plus text-marine' />
      </button>
    )}
  </div>
);

export default ImageElement;
